import type { PopupButtonConfig } from '@onetext/api';
import { FONT_WEIGHT, TEXT_TRANSFORM } from '@onetext/api';

export const buttonConfig : PopupButtonConfig = {
    level: {
        primary: {
            style: {
                text: {
                    base:  '#ffffff',
                    hover: '#ffffff'
                },
                background: {
                    base:  'rgba(56,49,255,1)',
                    hover: 'rgba(39,0,228,1)'
                }
            }
        },
        secondary: {
            style: {
                text: {
                    base:  '#ffffff',
                    hover: '#ffffff'
                },
                background: {
                    base:  'rgba(56,49,255,0.25)',
                    hover: 'rgba(39,0,228,0.4)'
                }
            }
        }
    },
    size: {
        default: {
            style: {
                textTransform: TEXT_TRANSFORM.UPPERCASE,
                height:        '53px',
                borderRadius:  '100px',
                fontSize:      '19px',
                lineHeight:    '1em',
                fontWeight:    FONT_WEIGHT._700
            }
        }
    }
};
